import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Checkbox,Divider,FormControl,FormControlLabel,IconButton,InputLabel,MenuItem,Select,Stack,TextField,Tooltip,Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { NewFormContext } from "../../context/NewFormContext";
import { ChecklistSubitem,ChecklistType,ItemChecklist } from "../../types/checklist/types";
import DeletaSubitem from "./Modal/DeletaSubitem";
import Help from "./Modal/Help";
import RemoveQrCode from "./Modal/RemoveQrCode";
import SubitemPermissions from "./SubitemPermissions";
import SubitemTypes from "./SubitemTypes";

const key = 'checklists.subitemModal.';
const questionKey = 'checklists.subitemModal.questionTypes.';

type props = {
  subitem: ChecklistSubitem,
  indexItem: number,
  indexSubitem: number,
  itemId: string,
  item: ItemChecklist,
  handleDragDisableSubitem: Function,
  handleCopySubitem: Function,
  handleOpen: Function,
  open: string[]
};

export default function EditSubitem({
  subitem,
  indexItem,
  indexSubitem,
  itemId,
  item,
  handleDragDisableSubitem,
  handleCopySubitem,
  handleOpen,
  open }: props) {
  const { setModelo, modelo } = useContext(NewFormContext);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalQrCode, setOpenModalQrCode] = useState<boolean>(false);
  const [openModalHelp, setOpenModalHelp] = useState<boolean>(false);
  const subitemId = subitem.id;
  const { t } = useTranslation('translation');
  const subitemKey = `${itemId}|${subitem.id}`;

  const optionsSelectMap = {
    avaliacao: t(questionKey + 'avaliation'),
    list: t(questionKey + 'textList'),
    data: t(questionKey + 'date'),
    hora: t(questionKey + 'hour'),
    numero: t(questionKey + 'number'),
    assinatura: t(questionKey + 'signature'),
    email: 'e-mail',
    telefone: t(questionKey + 'tel'),
    // rg: 'RG',
    cpfcnpj: 'CPF/CNPJ',
    cep: 'CEP',
    placa: t(questionKey + 'placa'),
    valorMedida: 'Valor/Medida',
    unique: 'Seleção',
    textoCurto: 'Texto'
  };

  function handleCloseModal() {
    setOpenModal(!openModal);
  }

  function handleCloseModalQrCode() {
    setOpenModalQrCode(!openModalQrCode);
  }

  function handleCloseModalHelp() {
    setOpenModalHelp(!openModalHelp);
  }

  function multipleTypesValue(value: string) {
    if (value === 'multiple') {
      return 'unique';
    } if (value === 'textoLongo') {
      return 'textoCurto';
    } else return value;
  }

  function handelQrCode(eve: React.ChangeEvent<HTMLInputElement>) {
    const posicao = `${indexItem}||${indexSubitem}`;
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.map((currentSubitem) =>
              currentSubitem.id === subitemId
                ? { ...currentSubitem, geraQrCode: eve.target.checked }
                : currentSubitem
            )
          }
          : item
      ),
      modeloQrCode: {
        ...prev.modeloQrCode,
        [posicao]: {
          nome: subitem.nome,
          tipo: subitem.tipo,
          posicao: posicao
        }
      }
    }));
  }

  function subitemModelByType(type: string, index: number): ChecklistSubitem {
    let subitem = {} as ChecklistSubitem;
    switch (type) {
      case 'data':
      case 'hora':
        subitem = {
          tipo: type,
          abrePlano: false,
          comentario: false,
          nome: `Subitem ${index}`,
          itemid: itemId,
          id: index,
          obrigatoriedade: {
            preenchimento: false,
            ocorrencia: false
          },
        };
        break;
      case 'cep':
      case 'cpfcnpj':
      case 'email':
      case 'placa':
      case 'telefone':
      case 'textoCurto':
      case 'textoLongo':
        subitem = {
          tipo: type,
          galeriaFoto: false,
          abrePlano: false,
          permiteArquivo: false,
          foto: false,
          nome: `Subitem ${index}`,
          itemid: itemId,
          id: index,
          obrigatoriedade: {
            preenchimento: false,
            obrigaArquivo: false,
            img: false,
          },
        };
        break;
      case 'avaliacao':
        subitem = {
          tipo: type,
          galeriaFoto: false,
          geraQrCode: false,
          abrePlano: false,
          permiteArquivo: false,
          hideImg: true,
          hideComent: true,
          peso: 0,
          padrao: null,
          nome: `Subitem ${index}`,
          itemid: itemId,
          id: index,
          obrigatoriedade: {
            NA: {
              obrigaArquivo: false,
              img: false,
              ocorrencia: false
            },
            conforme: {
              obrigaArquivo: false,
              img: false,
              ocorrencia: false
            },
            naoConforme: {
              obrigaArquivo: false,
              img: false,
              ocorrencia: false
            },
            preenchimento: false
          },
          avaliacao: [
            { nome: 'não conforme', valor: 0 },
            { nome: 'conforme', valor: 100 }
          ]
        };
        break;
      case 'unique':
      case 'multiple':
        subitem = {
          tipo: type,
          galeriaFoto: false,
          geraQrCode: false,
          abrePlano: false,
          permiteArquivo: false,
          foto: false,
          comentario: false,
          tipoSelecao: 'default',
          padrao: null,
          nome: `Subitem ${index}`,
          itemid: itemId,
          id: index,
          obrigatoriedade: {
            preenchimento: false,
            obrigaArquivo: false,
            img: false,
            ocorrencia: false
          },
          selecao: ['item 1', 'item 2'],
        };
        break;
      case 'list':
      case 'numero':
      case 'assinatura':
      case 'valorMedida':
        subitem = {
          tipo: type,
          galeriaFoto: false,
          geraQrCode: false,
          abrePlano: false,
          permiteArquivo: false,
          foto: false,
          comentario: false,
          nome: `Subitem ${index}`,
          itemid: itemId,
          id: index,
          obrigatoriedade: {
            preenchimento: false,
            obrigaArquivo: false,
            img: false,
            ocorrencia: false
          },
        };
        break;
    }
    return subitem;
  }

  return (
    <>
      {openModalQrCode
        && <RemoveQrCode
          open={openModalQrCode}
          handleCloseModal={handleCloseModalQrCode}
          subitem={subitem}
        />}
      {openModal
        && <DeletaSubitem
          open={openModal}
          handleCloseModal={handleCloseModal}
          itemId={item.id}
          nome={subitem.nome}
          subitemId={subitem.id} />}
      {<Help
        index={subitem.id}
        itemId={item.id}
        subitem={subitem}
        handleCloseModal={handleCloseModalHelp}
        open={openModalHelp} />}
      <Stack paddingLeft={3} paddingRight={3} padding={1.5} direction='column' alignItems='center' justifyContent='flex-start' width={'100%'} spacing={2} sx={{ backgroundColor: '#F3F3F4' }}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' width='100%'>
          <Typography variant="h6" color="success" fontWeight={600}>{indexItem + 1}.{indexSubitem + 1} - {subitem?.nome}</Typography>
          <Grid size={1}>
            <Stack direction='row' spacing={.5}>
              <Tooltip title='Ajuda'>
                <span>
                  <IconButton color='warning' onClick={handleCloseModalHelp}>
                    <HelpOutlineIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title='Exibir/Ocultar subitem'>
                <span>
                  <IconButton color="info" onClick={() => handleOpen(subitemKey)}>
                    {open?.includes(subitemKey)
                      ? <VisibilityOffIcon />
                      : <RemoveRedEyeIcon />}
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title='Copiar subitem'>
                <span>
                  <IconButton color="success" onClick={() => handleCopySubitem(subitem, itemId)}>
                    <ContentCopyIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title='Deletar subitem'>
                <span>
                  <IconButton color="error"
                    onClick={handleCloseModal}
                    disabled={modelo?.itens.find((item) => item.id === itemId)?.subitens.length === 1}>
                    <DeleteIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          </Grid>
        </Stack>
        {open?.includes(subitemKey) && <>
          <Divider variant="middle" color='success' flexItem orientation='horizontal' />
          <Grid container width='100%' sx={{ padding: 1 }}>
            <Stack direction='column' width='100%' spacing={1} justifyContent='flex-start' alignItems='flex-start'>
              <Stack direction='row' spacing={1} justifyContent='flex-start' alignItems='center' width='100%'>
                <Grid size={4}>
                  <TextField
                    label='Nome do subitem'
                    fullWidth
                    value={subitem.nome}
                    onChange={
                      (eve) =>
                        setModelo((prev: ChecklistType) => ({
                          ...prev,
                          itens: prev.itens.map((item) =>
                            item.id === itemId
                              ? {
                                ...item,
                                subitens: item.subitens.map((currentSubitem) =>
                                  currentSubitem.id === subitemId
                                    ? { ...currentSubitem, nome: eve.target.value }
                                    : currentSubitem
                                )
                              }
                              : item
                          )
                        }))
                    } />
                </Grid>
                <Grid size={2}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">{t(key + 'questionType')}</InputLabel>
                    <Select
                      value={multipleTypesValue(subitem.tipo)}
                      label={t(key + 'questionType')}
                      onChange={(eve) => setModelo((prev: ChecklistType) => ({
                        ...prev,
                        itens: prev.itens.map((item) =>
                          item.id === itemId
                            ? {
                              ...item,
                              subitens: item.subitens.map((currentSubitem) =>
                                currentSubitem.id === subitemId
                                  ? {
                                    ...subitemModelByType(eve.target.value, currentSubitem.id),
                                    id: currentSubitem.id,
                                    itemid: currentSubitem.itemid,
                                    nome: currentSubitem.nome,
                                    tipo: eve.target.value
                                  }
                                  : currentSubitem
                              )
                            }
                            : item
                        )
                      }))}
                    >{Object.keys(optionsSelectMap).map((tipo: string) => (
                      <MenuItem key={tipo} value={tipo}>{optionsSelectMap[tipo as keyof typeof optionsSelectMap]}</MenuItem>
                    ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid>
                  {modelo && !modelo.preenchimentoDeslogado
                    && <Tooltip title={`${t('checklists.Modal.formNeedsIdentifier')}`}>
                      <span>
                        <FormControlLabel
                          disabled={!modelo.identificadorLista}
                          labelPlacement="start"
                          control={<Checkbox
                            checked={subitem.geraQrCode ?? false}
                            onChange={!subitem.geraQrCode ? (eve) => handelQrCode(eve) : () => handleCloseModalQrCode()}
                          />} label={t('checklists.Modal.generatePreFilledQRCode')} />
                      </span>
                    </Tooltip>}
                </Grid>
              </Stack>
              <SubitemTypes subitem={subitem} itemId={item.id} indexSubitem={subitem.id} />
              <SubitemPermissions
                itemId={item.id}
                subitem={subitem}
                indexSubitem={subitem.id} />
            </Stack>
          </Grid>
        </>}
      </Stack >
    </>
  );
}
